import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { formatApiErrorDetail } from "@/lib/api";
import { Radar, Loader2, Gift } from "lucide-react";

export default function Register() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await register(email, password, name);
      navigate("/dashboard");
    } catch (e) {
      setError(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex bg-grid">
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-sm">
          <Link to="/" className="flex items-center gap-2.5 mb-8">
            <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-emerald-500 to-emerald-700 flex items-center justify-center">
              <Radar className="w-5 h-5 text-emerald-950" />
            </div>
            <div className="font-display text-xl font-extrabold">LeilãoRadar AI</div>
          </Link>
          <h1 className="font-display text-3xl font-bold text-white">Crie sua conta</h1>
          <div className="mt-3 inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-amber-500/10 border border-amber-500/30 text-amber-300 text-xs">
            <Gift className="w-3.5 h-3.5" /> Ganhe 10 créditos grátis para começar
          </div>

          <form onSubmit={onSubmit} className="mt-6 space-y-4" data-testid="register-form">
            <div>
              <Label htmlFor="name" className="text-slate-300">Nome</Label>
              <Input id="name" required value={name} onChange={(e) => setName(e.target.value)}
                className="mt-1.5 bg-slate-900 border-slate-800 h-11" data-testid="register-name-input" />
            </div>
            <div>
              <Label htmlFor="email" className="text-slate-300">Email</Label>
              <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="mt-1.5 bg-slate-900 border-slate-800 h-11" data-testid="register-email-input" />
            </div>
            <div>
              <Label htmlFor="password" className="text-slate-300">Senha (mín. 6)</Label>
              <Input id="password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)}
                className="mt-1.5 bg-slate-900 border-slate-800 h-11" data-testid="register-password-input" />
            </div>
            {error && <div className="text-sm text-red-400" data-testid="register-error">{error}</div>}
            <Button type="submit" disabled={loading} className="w-full h-11 bg-emerald-500 hover:bg-emerald-600 text-emerald-950 font-semibold" data-testid="register-submit-btn">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Criar conta"}
            </Button>
          </form>
          <p className="mt-6 text-sm text-slate-400 text-center">
            Já tem conta? <Link to="/login" className="text-emerald-400 hover:text-emerald-300" data-testid="register-to-login">Entrar</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
